import { Flex, Box, Badge, Text } from "theme-ui";
import { MenuLink } from "./MenuLink";
import { useLiquity } from "../hooks/LiquityContext";
import React, { ReactNode } from 'react';

interface LinkProps {
  children: ReactNode;
  href: string;
}

const TemporaryNewBadge = () => {
  const isBeforeNovember2022 = new Date() < new Date("2022-11-01");
  if (!isBeforeNovember2022) return null;
  return (
    <Badge ml={1} sx={{ fontSize: "12px" }}>
      New
    </Badge>
  );
};


export const Nav: React.FC = () => {
  const { collateral } = useLiquity();

  return (
    <Box as="nav" 
      sx={{ display: ["none", "flex"], 
      alignItems: "center", 
      flex: 1, 
      fontWeight: 'bold', 
      paddingLeft: "12px"}}>

        <MenuLink to="/" >Mint</MenuLink>
        <MenuLink to="/pool" >Stability Pool</MenuLink>
        <MenuLink to="/staking" >Staking</MenuLink>
        {/* <MenuLink to="/redemption" >Redemption</MenuLink> */}
        <MenuLink to="/risky-troves" >Risky Troves</MenuLink>

    </Box>
  );
};
